<!--优惠券卡片-->
<template>
    <div class="city">
        <div class="choosed">
            <div>当前选择城市</div>
            <span>{{current_city}}</span>
        </div>
        <van-index-bar :index-list="indexList">
            <div v-for="(item,index) in cityList" :key="item.initial">
                <van-index-anchor :index="item.initial" />
                <van-cell v-for='(item2,index2) in item.city' :title="item2" :key="item2" is-link @click="selectCity(index,index2)"/>
            </div>


        </van-index-bar>
    </div>
</template>

<script>
    let from_router = {} // 上级页面路由
    export default {
        name: "chooseCity",
        data() {
            return {
                current_city: '',  //选中的城市
                indexList:["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T","U","V","W","X","Y","Z"],
                cityList:[
                {
                    initial:'A',
                    city:['鞍山','安庆',]
                },{
                    initial:'B',
                    city:['北京']
                },{
                    initial:'C',
                    city:['重庆','承德','长春','常州','长沙','常德','成都']
                },{
                    initial:'D',
                    city:['大连','丹东','大庆']
                },{
                    initial:'E',
                    city:['鄂州']
                },{
                    initial:'F',
                    city:['抚州','福州','佛山']
                },{
                    initial:'G',
                    city:['赣州','广州','贵阳']
                },{
                    initial:'H',
                    city:['哈尔滨','鹤岗','杭州','合肥','黄山市','鹤壁','黄冈','惠州','海口']
                },/*{
                    initial:'I',
                    city:['']
                },*/{
                    initial:'J',
                    city:['吉安','景德镇','九江','晋中','锦州','吉林','嘉兴','济南','荆州','江门']
                },{
                    initial:'K',
                    city:['开封','昆明']
                },{
                    initial:'L',
                    city:['廊坊','连云港','洛阳','丽江','兰州']
                },{
                    initial:'M',
                    city:['马鞍山','梅州']
                },{
                    initial:'N',
                    city:['南昌','南京','南通','宁波','南充']
                },/*{
                    initial:'O',
                    city:['']
                },*/{
                    initial:'P',
                    city:['萍乡']
                },{
                    initial:'Q',
                    city:['秦皇岛','齐齐哈尔','泉州','青岛']
                },/*{
                    initial:'R',
                    city:['']
                },*/{
                    initial:'S',
                    city:['上饶','上海','石家庄','沈阳','苏州','随州','深圳','汕头','韶关','三亚']
                },{
                    initial:'T',
                    city:['天津','唐山','太原','通化','台州']
                },/*{
                    initial:'U',
                    city:['']
                },{
                    initial:'V',
                    city:['']
                },*/{
                    initial:'W',
                    city:['无锡','温州','芜湖','武汉']
                },{
                    initial:'X',
                    city:['新余','徐州','厦门','咸宁','湘潭','西安','西宁']
                },{
                    initial:'Y',
                    city:['宜春','鹰潭','扬州','烟台','益阳','岳阳']
                },{
                    initial:'Z',
                    city:['张家口','镇江','漳州','淄博','郑州','张家界','珠海','湛江','肇庆']
                }],
            }
        },
        mounted() {
            this.current_city = this.$route.query.current_city
        },
        // 钩子函数，在进入页面时，获取上级页面路由
        beforeRouteEnter(to, from, next) {
            next(vm =>{ // 这里的vm指的就是vue实例，可以用来当做this使用（在内部获取不到外部的this）
                from_router = from
                // console.log('to', to)
                // console.log('from', from)
            })
        },
        methods: {
            // 选择某一城市事件：选择后，跳回到上级页面(并传回选择的城市 参数名 select_city)
            selectCity(i,i2){
                let select_city = this.cityList[i].city[i2]
                this.current_city = select_city
                this.$router.push({name: from_router.name, query: {select_city: select_city}})
                // this.$router.go(-1)
            }
        }

    }
</script>

<style lang="scss" scoped>
.choosed {
    padding: 20px;
    background-color: rgb(249,249,249);
    div {
        font-size: 14px;
        color:#23274D;
        font-weight: 600;
        margin-bottom: 14px;
    }
    span {
        font-size: 12px;
        color:#fff;
        background-color: #D8D8D8;
        padding: 6px 12px;
        border-radius: 15px;
    }
}
</style>